<template>
  <Modal
    :show="showLinkModal"
    @close="applyChange(currentLink)"
  >
    <template #title>
      Add Link
    </template>

    <template #content>
      <div class="mb-4">
        Enter the URL for the selected text
      </div>

      <DpplTextField
        :value="currentUrl"
        custom-label="URL"
        autofocus
        outlined
        dense
        @update:model-value="(value) => url = value"
        @keyup.enter="applyChange(currentUrl)"
      />
    </template>

    <template #actions>
      <div class="d-flex w-100 ga-4">
        <div class="flex-grow-1 w-100">
          <v-btn
            class="w-100"
            variant="outlined"
            color="primary"
            rounded="lg"
            @click="applyChange('')"
          >
            Remove Link
          </v-btn>
        </div>

        <div class="flex-grow-1 w-100">
          <v-btn
            class="w-100"
            color="primary"
            rounded="lg"
            variant="flat"
            type="submit"
            @click="applyChange(currentUrl)"
          >
            Apply Link
          </v-btn>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import Modal from '@/components/shared/Modal.vue';
import { useDocumentEditorToolbar } from '@/stores/document/editorToolbar';
import { mapState } from 'pinia';

export default {
  name: 'EditLinkModal',
  components: {
    Modal,
    DpplTextField,
  },
  emits: ['updateLink'],
  data() {
    return {
      url: '',
      updated: false,
    };
  },
  computed: {
    ...mapState(useDocumentEditorToolbar, ['showLinkModal', 'currentLink']),
    currentUrl() {
      return this.updated ? this.url : this.currentLink;
    },
  },
  watch: {
    url(newVal) {
      if (newVal) {
        this.updated = true;
      }
    },
  },
  methods: {
    applyChange(link) {
      this.$emit('updateLink', { link });
      this.url = '';
      this.updated = false;
    },
  },
};
</script>
